import { useEffect, useRef, useState } from "react";
import { getOpenAI } from "../services/api";

const TextBox = ({
  title,
  forID,
  val,
  handleChange,
  para = true,
  trans,
  orgVal,
  handleTextGo,
  handleTextSum,
  refresh,
  summarize,
}) => {
  const [local, setLocal] = useState("");
  const [loading, setLoading] = useState(true);
  const textRef = useRef(null);

  useEffect(() => {
    async function startMe() {
      if (para && val === "" && orgVal) {
        setLoading(true);
        const textBox = textRef.current;
        let response = null;
        if (summarize) {
          response = await getOpenAI(orgVal, trans, 2);
        } else if (trans === "English") {
          response = await getOpenAI(orgVal, trans, 1);
        } else {
          response = await getOpenAI(orgVal, trans);
        }
        handleChange({ target: { id: textBox.id, value: response } });
        setLocal(response);
        setLoading(false);
      } else {
        setLocal(val);
        setLoading(false);
      }
    }
    startMe();
  }, [trans, refresh, para]);

  async function handleSummarize() {
    setLoading(true);
    let text = local;
    let res = await getOpenAI(text, trans, 2);
    const textBox = textRef.current;
    setLoading(false);
    handleChange({ target: { id: textBox.id, value: res } });
    setLocal(res);
  }

  useEffect(() => {}, [loading]);

  async function handleParaphrase() {
    setLoading(true);
    const textarea = textRef.current;
    let aux = textarea.value;
    let text = textarea.value;
    let res = null;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    if (start !== end) {
      text = aux.substring(start, end);
    }
    res = await getOpenAI(text, trans, 1);

    if (start !== end) {
      aux = aux.substring(0, start) + " " + res + " " + aux.substring(end);
    } else {
      aux = res;
    }

    handleChange({ target: { id: textarea.id, value: aux } });
    setLoading(false);
    setLocal(aux);
  }

  function localChange(e) {
    setLocal(e.target.value);
    handleChange(e);
  }

  function boldText(e) {
    let text = local;
    if (e.key === "b" || e.key === "B") {
      let selection = window.getSelection().toString();
      let len = selection.length;
      if (len) {
        e.preventDefault();
        let pos = e.target.selectionStart;
        text = `${text.slice(0, pos)}<b>${selection}</b>${text.slice(
          pos + len,
          text.length,
        )}`;
        setLocal(text);
        let textBox = textRef.current;
        handleChange({ target: { id: textBox.id, value: text } });
      } else {
        return;
      }
    } else if (e.key === "`") {
      e.preventDefault();
      let pos = e.target.selectionStart;
      let imgName = window.prompt("Insert image name");
      let check = imgName.split(".").pop();
      if (
        check !== "jpg" &&
        check !== "png" &&
        check !== "jpeg" &&
        check !== "gif" &&
        check !== "bmp" &&
        check !== "tiff"
      ) {
        imgName = window.prompt("Insert image name with format at the end");
      }
      if (imgName) {
        text = `${text.slice(
          0,
          pos,
        )}<br/><img src='https://www.energymarketprice.com/news-management-panel/uploads/1_Content Images/${imgName}' style='width:740px;'/><br/>${text.slice(
          pos + 1,
          text.length,
        )}`;
        setLocal(text);
        let textBox = textRef.current;
        handleChange({ target: { id: textBox.id, value: text } });
      }
    } else {
      return;
    }
  }

  return (
    <>
      <div className={forID !== "text" ? "halfFlex" : "customFlex"}>
        <div
          className={
            forID !== "text"
              ? "labelDiv textLabelDiv"
              : "labelDiv textLabelDiv flex-col"
          }
        >
          <label htmlFor={forID}>{title}</label>
          {forID !== "text" ? (
            <>
              <button
                className="block custombtn"
                type="button"
                onClick={() => handleParaphrase()}
              >
                Paraphrase
              </button>
              <button
                className="block custombtn"
                type="button"
                onClick={() => handleSummarize()}
              >
                Summarize
              </button>
            </>
          ) : (
            <>
              <button
                className="block custombtn"
                type="button"
                onClick={() => handleTextGo()}
              >
                Go
              </button>
              <button
                className="block custombtn"
                type="button"
                onClick={() => handleTextSum()}
              >
                Summarize
              </button>
            </>
          )}
        </div>
        <div
          className={
            loading ? (forID !== "text" ? "" : "customFlex") : "hidden"
          }
        >
          <div className="flex items-center justify-center w-full">
            <div className="w-[200px] h-[160px] relative">
              <div className="loader absolute top-[70px] left-[100px]"></div>
            </div>
          </div>
        </div>
        <div
          className={
            !loading ? (forID !== "text" ? "" : "customFlex") : "hidden"
          }
        >
          <div
            className={
              forID !== "text"
                ? "flex items-center w-full flex-col"
                : "flex items-center w-full"
            }
          >
            <div className="inputDiv">
              <textarea
                ref={textRef}
                id={forID}
                className="customInput"
                value={local}
                onChange={(e) => localChange(e)}
                onKeyDown={para ? null : (e) => boldText(e)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TextBox;
